import { render, staticRenderFns } from "./UiLayoutHeader.vue?vue&type=template&id=34b90ec0&scoped=true"
import script from "./UiLayoutHeader.vue?vue&type=script&lang=js"
export * from "./UiLayoutHeader.vue?vue&type=script&lang=js"
import style0 from "./UiLayoutHeader.vue?vue&type=style&index=0&id=34b90ec0&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b90ec0",
  null
  
)

export default component.exports